/* eslint-disable import/prefer-default-export */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import CustomWrapRootElement from './WrapRootElement';

export const wrapRootElement = CustomWrapRootElement;
